const loginTypes = {
  SET_IS_LOGGED: 'LOGIN/SET_IS_LOGGED',
  LOGIN: 'LOGIN/LOGIN',
  LOGIN_SUCCESS: 'LOGIN/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN/LOGIN_FAILURE',
  LOGOUT: 'LOGIN/LOGOUT'
}

export default loginTypes
